import { Shield, Award, Lock, CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { motion } from "framer-motion";

const TrustIndicators = () => {
  const badges = [
    { icon: Shield, label: "ISO 27001", color: "text-blue-400" },
    { icon: Lock, label: "GDPR", color: "text-green-400" },
    { icon: Award, label: "SOC 2", color: "text-purple-400" },
    { icon: CheckCircle, label: "EU AI Act", color: "text-cyan-400" },
  ];

  return (
    <section className="py-16 relative z-10">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row items-center justify-between gap-8 p-8 rounded-2xl bg-card/30 backdrop-blur-sm border border-white/10"
        >
          <div className="flex items-center gap-6">
            <h3 className="text-2xl font-bold gradient-brand-text">
              Enterprise Security & Compliance
            </h3>
            <div className="flex items-center gap-4">
              {badges.map((badge, index) => (
                <motion.div
                  key={badge.label}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.4 }}
                  className="flex flex-col items-center gap-1 p-3 rounded-xl bg-background/50 hover:bg-background/70 transition-all hover-lift"
                >
                  <badge.icon className={`w-8 h-8 ${badge.color}`} />
                  <span className="text-xs font-medium text-muted-foreground">{badge.label}</span>
                </motion.div>
              ))}
            </div>
          </div>
          
          <Link to="/compliance">
            <Button variant="outline" size="lg" className="hover-lift">
              View Full Compliance →
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustIndicators;
